import { combineReducers } from "redux";
import { authenReducer } from "./authenReducer";
import { myRecordReducer } from "./myRecordReducer";
import { listingReducer } from "./listingReducer";
import { eitShopReducer } from "./eitShopReducer";
import { eitShopSoldReducer } from "./eitShopSoldReducer";
import { taskReducer } from "./taskReducer";
import { collectionReducer } from "./collectionReducer";
import { botReducer } from "./botReducer";
import { socketReducer } from "./socketReducer";
import { miscReducer } from "./miscReducer";
import { localDataReducer } from "./localDataReducer";
import { etsyShopReducer } from "./etsyShopReducer";
import { agentReducer } from "./agentReducer";
import { orderReducer } from './orderReducer';
import { sesProductReducer } from "./sesProductReducer";
import { sesProductVersionReducer } from "./sesProductVersionReducer";
import { sesProductQtyChangeReducer } from "./sesProductQtyChangeReducer";
import { sivProductInventoryTransactionReducer } from "./sivProductInventoryTransactionReducer";
import { permissionsReducer } from "./permissionsReducer";
import { userGroupsReducer } from "./userGroupsReducer";
import { userReducer } from './userReducer';
import { k3docReducer } from './k3docReducer';
import companyReducer from './companyReducer';
import { tkt1C3DInfoReducer } from './tkt1C3DInfoReducer';
import tkt1TrustedPersonReducer from './tkt1TrustedPersonReducer';
import { tkt1NetworkModemReducer } from './tkt1NetworkModemReducer';
import { tkt1PCInfoReducer } from './tkt1PCInfoReducer';
import { tkt1DevicePackReducer } from './tkt1DevicePackReducer';
import { tkt1BankBrandReducer } from './tkt1BankBrandReducer';
import { tkt1TrustedBankAccountReducer } from './tkt1TrustedBankAccountReducer';
import { tkt1TrustedBankVisaReducer } from './tkt1TrustedBankVisaReducer';
import tkt1ScanPersonReducer from './tkt1ScanPersonReducer';
import { tkt1TrustedStoryReducer } from './tkt1TrustedStoryReducer';
import { tkt1EtsyInfoPackReducer } from './tkt1EtsyInfoPackReducer';
import { tkt1SimReducer } from './tkt1SimReducer';
import { tkt1EmailReducer } from './tkt1EmailReducer';
import { tkt1FileUploadManagementReducer } from './tkt1FileUploadManagementReducer';
import { tkt1ImageAlbumReducer } from './tkt1ImageAlbumReducer';
import { tkt1RegisteredEtsyShopReducer } from './tkt1RegisteredEtsyShopReducer';
import { tkt1ProductReducer } from './tkt1ProductReducer';
import { tkt1OnmDesignReducer } from './tkt1OnmDesignReducer';
const reducers = combineReducers({
  authenReducer,
  myRecordReducer,
  listingReducer,
  eitShopReducer,
  eitShopSoldReducer,
  taskReducer,
  collectionReducer,
  botReducer,
  socketReducer,
  miscReducer,
  localDataReducer,
  etsyShopReducer,
  agentReducer,
  orderReducer,
  sesProductReducer,
  sesProductVersionReducer,
  sesProductQtyChangeReducer,
  sivProductInventoryTransactionReducer,
  permissionsReducer,
  userGroupsReducer,
  userReducer,
  k3docReducer,
  companyReducer,
  tkt1C3DInfoReducer,
  tkt1TrustedPersonReducer,
  tkt1NetworkModemReducer,
  tkt1PCInfoReducer,
  tkt1DevicePackReducer,
  tkt1BankBrandReducer,
  tkt1TrustedBankAccountReducer,
  tkt1TrustedBankVisaReducer,
  tkt1ScanPersonReducer,
  tkt1TrustedStoryReducer,
  tkt1EtsyInfoPackReducer,
  tkt1SimReducer,
  tkt1EmailReducer,
  tkt1FileUploadManagementReducer,
  tkt1ImageAlbumReducer,
  tkt1RegisteredEtsyShopReducer,
  tkt1ProductReducer,
  tkt1OnmDesignReducer
});

export default reducers;
